import React from "react";
import DocumentDetailField, {
  DocumentDetailFieldProps,
} from "./DocumentDetailField";

interface DocumentDetailTagFieldProps extends DocumentDetailFieldProps {
  tags?: [];
}

const DocumentDetailTagField = ({
  label,
  children,
  ...rest
}: DocumentDetailTagFieldProps) => {
  return (
    <DocumentDetailField {...rest} label={label} padding="3rem 0">
      {children}
    </DocumentDetailField>
  );
};

export default DocumentDetailTagField;
